module.exports = __webpack_public_path__ + "static/media/tick-circle.307f7a68.svg";